import styled, { css } from "styled-components";

import { StyledTableRowFieldProps } from "./types";

export const StyledTableRowField = styled.tr<StyledTableRowFieldProps>`
  ${({ hasError }) =>
    hasError &&
    css`
      color: #d4380d;
      background: #fff2e8;
      border: 1px solid #ffbb96;
      border-radius: 4px;
    `}
`;
